import React from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import SmallProductItem from "../SmallProductItem";
import TowSearch from "./TowSearch";
import { LoadScript } from "@react-google-maps/api";

function TowScreenSideBar({ latests }) {
    const GOOGLE_MAPS_API_KEY = "AIzaSyDxpKBuxXpQRXU3XL97I4qqf2dbE_5M7Z0";

  return (
    <aside className="col-sm-4 col-md-3 content-aside" id="column-left">
           <LoadScript
      googleMapsApiKey={GOOGLE_MAPS_API_KEY}
      libraries={["places"]} 
    >   <TowSearch apiKey={GOOGLE_MAPS_API_KEY} />

    </LoadScript>
   
  
    </aside>
  );
}

export default TowScreenSideBar;
